
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';

export const ADD_MEDICALCONDITION_RESULT = '[MEDICALCONDITION] Add';
export const REMOVE_MEDICALCONDITION_RESULT = '[MEDICALCONDITION] Remove';


export class AddMedicalConditionResult implements Action {
    readonly type = ADD_MEDICALCONDITION_RESULT;

    constructor(public payload: any) { }
}
// RemovePersonalDetails
export class RemoveMedicalConditionResult implements Action {
    readonly type = REMOVE_MEDICALCONDITION_RESULT;

    constructor(public payload: number) { }
}

export type Actions = AddMedicalConditionResult | RemoveMedicalConditionResult;
